import { createConfigSection } from '../helpers'

export default {
    ...createConfigSection('api', {
        base: 'https://beheer-test-api.agressieregistratieoverheid.nl',
        requestTimeout: 2000
    }),

    ...createConfigSection('oidc', {
        authority: 'https://backend-l7tqmyeu6v2kq.azurewebsites.net',
        post_logout_redirect_uri: 'https://beheer-test.agressieregistratieoverheid.nl'
    })
}
